import { palette } from '../../styles/tokens';
import { Card } from '../common/Card';

interface Props {
  modulesEnabled: string[];
  tier: string;
}

const ALL_MODULES: { key: string; label: string; minTier: string }[] = [
  { key: 'schedule', label: 'Schedule', minTier: 'free' },
  { key: 'work_orders', label: 'Work Orders', minTier: 'free' },
  { key: 'booking', label: 'Bookings', minTier: 'free' },
  { key: 'fleet', label: 'Fleet', minTier: 'starter' },
  { key: 'invoicing', label: 'Invoicing', minTier: 'starter' },
  { key: 'projects', label: 'Projects', minTier: 'starter' },
  { key: 'messaging', label: 'Messaging', minTier: 'starter' },
  { key: 'dispatch', label: 'Dispatch', minTier: 'growth' },
  { key: 'locations', label: 'Locations', minTier: 'starter' },
  { key: 'payments', label: 'Payments', minTier: 'growth' },
];

const TIER_ORDER = ['free', 'trial', 'starter', 'growth', 'business'];

export function ModulesSection({ modulesEnabled, tier }: Props) {
  const tierIdx = TIER_ORDER.indexOf(tier);

  return (
    <Card title="Active Modules">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px 16px' }}>
        {ALL_MODULES.map(m => {
          const enabled = modulesEnabled.includes(m.key);
          const tierRequired = TIER_ORDER.indexOf(m.minTier);
          const locked = !enabled && tierIdx < tierRequired;
          return (
            <div key={m.key} style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0',
              opacity: locked ? 0.5 : 1,
            }}>
              <div style={{
                width: 18, height: 18, borderRadius: 4,
                background: enabled ? palette.greenWash : palette.g100,
                border: `1px solid ${enabled ? palette.green : palette.g200}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 11, color: enabled ? palette.green : palette.g400,
              }}>
                {enabled ? '✓' : '✕'}
              </div>
              <span style={{ fontSize: 13, color: enabled ? palette.g800 : palette.g400, fontWeight: enabled ? 500 : 400 }}>
                {m.label}
              </span>
              {locked && (
                <span style={{ fontSize: 10, color: palette.g400, marginLeft: 'auto' }}>
                  requires {m.minTier}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
